import React from "react";
import { useLocation } from "react-router-dom";
import { Route, Routes } from "react-router-dom";

import Header from "./components/Header";
import ScrollToTop from "./components/ScrollToTop";
import Banner from "./components/Banner";
import Membership from "./components/Membership";
import News from "./components/news/News";
import Footer from "./components/Footer";
import Statistics from "./components/Statistics";
import AboutASG from "./components/AboutASG";
import ExecutiveOfficers from "./components/Executives";
import PageBanner from "./components/PageBanner";
import Council from "./components/Council";
import "./App.css";
import Categories from "./components/Categories";
import NewsCard1 from "./components/news/NewsCard1";
import NewsCard2 from "./components/news/NewsCard2";
import NewsCard3 from "./components/news/NewsCard3";
import NewsCard4 from "./components/news/NewsCard4";
import NewsCard5 from "./components/news/NewsCard5";
import NewsCard6 from "./components/news/NewsCard6";
import MembershipFeeTable from "./components/MembershipFeeTable";
import RecentPosts from "./components/RecentPosts";
import UniversityAccreditation from "./components/UniversityAccreditation";
import NotFound from "./components/NotFound";
import ASGPathway from "./components/ASGPathway";
import ASGConnect2024 from "./components/Event&CPD/ASGConnect2024";
import ASGConnect2025 from "./components/Event&CPD/ASGConnect2025";
import ConferenceNavigation from "./components/Event&CPD/ConferenceNavigation";
import ExamCalendar from "./components/ExamCalendar";
import ConferencePapers from "./components/Publications/ConferencePapers";
import PDFViewer from "./components/PDFViewer";
import PastQuestions from "./components/PastQuestions";
import WorkingGroups from "./components/About ASG/WorkingGroups";
import PAS from "./components/PAS";
import MortalityTable from "./components/MortalityTable";
import PrincipalActuariesList from "./components/PrincipalActuariesList";
import JobListPage from "./components/Jobs/JobListPage";
import JobDetailPage from "./components/Jobs/JobDetailPage";
import Syllabus from "./components/Syllabus";
import AdminPanel from "./components/Admin/AdminPanel";

function App() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  return (
    <div className="App">
      {!isAdminRoute && (
        <div className="header-wrapper">
          <Header />
        </div>
      )}
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <div className="banner-wrapper">
                <Banner />
                <Statistics />
              </div>
              <Membership />
              <News />
            </>
          }
        />

        {/* Admin Panel wrapper */}
        <Route path="/admin/*" element={<AdminPanel />} />

        <Route path="/about-asg" element={<><PageBanner /><AboutASG /></>} />
        <Route path="/working-group" element={<><PageBanner /><WorkingGroups /></>} />
        <Route path="/executives" element={<><div className="executive-wrapper"><PageBanner /><ExecutiveOfficers /></div></>} />
        <Route path="/council" element={<><PageBanner /><Council /></>} />
        <Route path="/categories" element={<><PageBanner /><Categories /></>} />
        <Route path="/LatestNews_1" element={<><PageBanner /><div className="news-card-wrapper"><NewsCard1 /><RecentPosts /></div></>} />
        <Route path="/LatestNews_2" element={<><PageBanner /><div className="news-card-wrapper"><NewsCard2 /><RecentPosts /></div></>} />
        <Route path="/LatestNews_3" element={<><PageBanner /><div className="news-card-wrapper"><NewsCard3 /><RecentPosts /></div></>} />
        <Route path="/LatestNews_4" element={<><PageBanner /><div className="news-card-wrapper"><NewsCard4 /><RecentPosts /></div></>} />
        <Route path="/LatestNews_5" element={<><PageBanner /><div className="news-card-wrapper"><NewsCard5 /><RecentPosts /></div></>} />
        <Route path="/LatestNews_6" element={<><PageBanner /><div className="news-card-wrapper"><NewsCard6 /><RecentPosts /></div></>} />
        <Route path="/membershipfeetable" element={<><PageBanner /><MembershipFeeTable /></>} />
        <Route path="/accrediteduniversities" element={<><PageBanner /><UniversityAccreditation /></>} />
        <Route path="/asgpathway" element={<><PageBanner /><ASGPathway /></>} />
        <Route path="/asg-conference2025" element={<><PageBanner /><div className="news-card-wrapper"><ASGConnect2025 /><ConferenceNavigation /></div></>} />
        <Route path="/asg-conference2024" element={<><PageBanner /><div className="news-card-wrapper"><ASGConnect2024 /><ConferenceNavigation /></div></>} />
        <Route path="/key-timelines" element={<><PageBanner /><ExamCalendar /></>} />
        <Route path="/conference-papers" element={<><PageBanner /><ConferencePapers /></>} />
        <Route path="/past-questions" element={<><PageBanner /><PastQuestions /></>} />
        <Route path="/pas-licenses" element={<><PageBanner /><PAS /></>} />
        <Route path="/MortalityTable" element={<><PageBanner /><MortalityTable /></>} />
        <Route path="/principalactuaries" element={<><PageBanner /><PrincipalActuariesList /></>} />
        <Route path="/jobs" element={<><PageBanner /><JobListPage /></>} />
        <Route path="/jobs/:id" element={<><PageBanner /><JobDetailPage /></>} />
        <Route path="/syllabus" element={<><PageBanner /><Syllabus /></>} />
        <Route path="/pdf-viewer/:file" element={<PDFViewer />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!isAdminRoute && <Footer />}
    </div>
  );
}

export default App;
